import { evidenceColumns } from "@redotech/redo-dispute-common/evidence-config";
import { disputeSource } from "@redotech/redo-dispute-db-schema/dispute-definition";
import * as z from "zod";

export const generateAllEvidence = {
  name: "generateAllEvidence" as const,
  input: z.object({
    disputeId: z.coerce.bigint(),
    source: z.enum(disputeSource),
    invalidDisputeReason: z.string().optional(),
    perSectionContext: z
      .array(
        z.object({
          column: z.enum(evidenceColumns),
          text: z.string().optional(),
          fileUrls: z.array(z.string()).optional(),
        }),
      )
      .optional(),
  }),
  output: z.object({
    success: z.boolean(),
    errors: z.array(z.string()).optional(),
  }),
};
